import { faPen } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Modal, Switch } from '@orobix/orobix-fe-components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useStyles } from './EditButton.styles'
import { useUpdateOptimizationProcess } from './useUpdateOptimizationProcess'

export const EditButton = ({
  optimizationProcessId,
  currentName,
  currentNotes,
  currentOfficial,
  showOfficial = true,
}: {
  optimizationProcessId: number
  currentName?: string
  currentNotes?: string
  currentOfficial?: boolean
  showOfficial?: boolean
}) => {
  const [editModal, setEditModal] = useState(false)
  const [name, setName] = useState('')
  const [notes, setNotes] = useState('')
  const [official, setOfficial] = useState(false)
  const { t } = useTranslation()
  const classes = useStyles()
  const { mutate: updateOptimizationProcess, isLoading } =
    useUpdateOptimizationProcess()

  const handleOpenModal = (e: React.MouseEvent) => {
    e.stopPropagation()
    setName(currentName ?? '')
    setNotes(currentNotes ?? '')
    setOfficial(currentOfficial ?? false)
    setEditModal(true)
  }

  const handleSave = () => {
    updateOptimizationProcess(
      { id: optimizationProcessId, name, notes, official },
      { onSuccess: () => setEditModal(false) }
    )
  }

  return (
    <>
      <Button
        icon={<FontAwesomeIcon icon={faPen} />}
        onClick={handleOpenModal}
        title={t('Edit')}
        label=""
        buttonType="button"
        type="blank-action"
        size="md"
      />
      {editModal && (
        <Modal
          title={t('Edit optimization process')}
          onCloseRequest={() => setEditModal(false)}
          footer={
            <Button
              label={t('Save')}
              type="action"
              onClick={handleSave}
              loading={isLoading}
              disabled={isLoading}
            />
          }
        >
          <div className={classes.fieldWrapper}>
            <label htmlFor="editProcessName" className={classes.fieldLabel}>
              {t('Name')}
            </label>
            <input
              id="editProcessName"
              type="text"
              maxLength={256}
              value={name}
              onChange={(e) => setName(e.target.value)}
              className={classes.textInput}
            />
          </div>
          <div>
            <label htmlFor="editProcessNotes" className={classes.fieldLabel}>
              {t('Notes')}
            </label>
            <textarea
              id="editProcessNotes"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              rows={3}
              className={classes.textarea}
            />
          </div>
          {showOfficial && (
            <div>
              <Switch
                id="editProcessOfficial"
                text={t('Official')}
                isToggled={official}
                onToggle={() => setOfficial((value) => !value)}
              />
            </div>
          )}
        </Modal>
      )}
    </>
  )
}
